import AuthAPI from './_auth'
import BoutiqueAPI from './_boutique'
import EmployeeAPI from './_employee'
import CustomerAPI from './_customer'

export default {
  ...AuthAPI,
  ...BoutiqueAPI,
  ...EmployeeAPI,
  ...CustomerAPI
}
